import apiService from './ApiService';

class AulaLinksService {
  async list(aulaId) {
    if (!aulaId) {
      throw new Error('No se encontró el aula.');
    }

    return apiService.get(`/aulas/${encodeURIComponent(aulaId)}/links`);
  }

  async create(aulaId, payload) {
    if (!aulaId) {
      throw new Error('No se encontró el aula.');
    }

    return apiService.post(`/aulas/${encodeURIComponent(aulaId)}/links`, {
      url: payload?.url || '',
      descripcion: payload?.descripcion || ''
    });
  }

  async update(aulaId, linkId, payload) {
    if (!aulaId) {
      throw new Error('No se encontró el aula.');
    }
    if (!linkId) {
      throw new Error('No se encontró el link.');
    }

    return apiService.put(`/aulas/${encodeURIComponent(aulaId)}/links/${encodeURIComponent(linkId)}`, {
      url: payload?.url || '',
      descripcion: payload?.descripcion || '',
      activo: payload?.activo !== false
    });
  }

  async delete(aulaId, linkId) {
    if (!aulaId) {
      throw new Error('No se encontró el aula.');
    }
    if (!linkId) {
      throw new Error('No se encontró el link.');
    }

    return apiService.delete(`/aulas/${encodeURIComponent(aulaId)}/links/${encodeURIComponent(linkId)}`);
  }
}

const aulaLinksService = new AulaLinksService();
export default aulaLinksService;
